import { action, makeObservable } from 'mobx';
import toastr from 'toastr';

export default class ToastrStore {
  constructor(
    rootStore,
    optionsOverride = {
      closeButton: true,
      timeOut: 5000,
    },
  ) {
    makeObservable(this, {
      message: action,
      success: action,
      error: action,
      warning: action,
      info: action,
      clear: action,
      remove: action,
    });

    this.rootStore = rootStore;
    toastr.options = {
      ...optionsOverride,
    };
  }

  message = (message, title, type) => {
    toastr[type](message, title);
  };

  success = (message, title) => {
    toastr.success(message, title);
  };

  error = (message, title, err) => {
    // console.log(message, title, err);
    toastr.error(message, title);
  };

  warning = (message, title, err) => {
    // console.log(message, title, err);
    toastr.warning(message, title);
  };

  info = (message, title) => {
    toastr.info(message, title);
  };

  clear = () => {
    toastr.clear();
  };

  remove = () => {
    toastr.remove();
  };
}
